import ProjectProcurementActivationPage from "../../shared/project-procurement-activation/ProjectProcurementActivationPage";

const SolarentOperatorProjectProcurementActivationPage = () => (
  <ProjectProcurementActivationPage source="SolarentOperator" />
);

export default SolarentOperatorProjectProcurementActivationPage;
